module.exports = __webpack_public_path__ + "static/media/architech_logo.dee22ff2.jpeg";